export enum RequestType {
  SuratKuasa = "Surat Kuasa",
  DokumenMaster = "Dokumen Master",
}

export namespace RequestType {
  export function toId(status: RequestType): string {
    switch (status) {
      case RequestType.SuratKuasa:
        return "RT230000001";
      case RequestType.DokumenMaster:
        return "RT230000002";
      default:
        return "";
    }
  }
}
